import {getMainRoute} from 'selectors/routing'
import {getSelectedCurrentTab as getSelectedContactsTab} from 'selectors/contacts'
import {getSelectedCurrentTab as getSelectedQuotingTab} from 'selectors/quotes'
import {getSelectedCurrentTab as getSelectedPurchasingTab} from 'selectors/purchasing'

export const getCurrentTab = (state) => {
  const mainRoute = getMainRoute(state)
  switch (mainRoute) {
    default:
    case 'contacts':
      return getSelectedContactsTab(state)

    case 'quoting':
      return getSelectedQuotingTab(state)

    case 'purchasing':
      return getSelectedPurchasingTab(state)
  }
}